export default __webpack_public_path__ + "static/media/loader.66a75633.svg";